// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"cb01a0c0","218":"0016381e","453":"553f868b","526":"52c494b0","705":"5ac33a38"}[chunkId] + ".chunk.js";
};